import { green, red } from '@mui/material/colors';
import React from 'react';

import { Close, Done } from '@mui/icons-material';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { AccessPointData } from '../../api/types';
import { AccessPointDetails } from '../AccessPointCard/AccessPointDetails';
import { useTranslations } from '../Translations/TranslationsProvider';

interface AccessSituationBannerProps {
    accessSituation: boolean;
    description?: string;
    accessInformation?: AccessPointData;
}

export const AccessSituationBanner: React.FC<AccessSituationBannerProps> = ({
    accessSituation,
    description,
    accessInformation,
}) => {
    const { translations } = useTranslations();

    if (!translations) {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '1rem',
                justifyContent: 'center',
                background: accessSituation ? green[800] : red[800],
                padding: '1rem 1rem 5rem',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    width: 'fit-content',
                    padding: '0.25rem 1.5rem',
                    margin: '0 auto',
                    color: 'white',
                }}
            >
                {accessInformation ? (
                    <AccessPointDetails accessInformation={accessInformation} translations={translations} />
                ) : description ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Typography variant="h6" fontWeight={600} textAlign={'center'}>
                            {description}
                        </Typography>
                    </Box>
                ) : null}
            </Box>

            {accessSituation ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Done sx={{ color: 'white' }} fontSize={'medium'} />
                    <Typography sx={{ color: 'white', fontWeight: 600 }} variant={'h6'}>
                        {translations.ACCESS_POINT_SITUATION_GRANTED}
                    </Typography>
                </Box>
            ) : (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Close sx={{ color: 'white' }} fontSize={'medium'} />
                    <Typography sx={{ color: 'white', fontWeight: 600 }} variant={'h6'}>
                        {translations.ACCESS_POINT_SITUATION_DENIED}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};
